import Form from "@/components/Form";
import fetchApi from "@/lib/fetchApi";
import { useSession } from "next-auth/react";
import React, { useState } from "react";
import { useForm } from "react-hook-form";

const FeedbackForm = ({
  resource,
  placeholderText = "",
  buttonLabel = "Submit",
}) => {
  const [isSaving, setIsSaving] = useState(false);

  const [flashMessage, setFlashMessage] = useState({
    message: null,
    type: null,
  });

  const { data: session, status } = useSession();

  const {
    register,
    handleSubmit,
    clearErrors,
    setError,
    formState: { isSubmitting, isValidating, errors },
  } = useForm();

  const handleFeedbackSubmit = async (data) => {
    setIsSaving(true);

    try {
      const result = await fetchApi("/api/resources/feedback", {
        method: "POST",
        body: JSON.stringify({
          resource: parseInt(resource.id, 10),
          resourceTitle: resource.title,
          text: data.text,
        }),
      });

      // Make sure we have success = true
      if (result.success) {
        setFlashMessage({
          message: "Your feedback has been shared successfully.",
          type: "success",
        });
      } else {
        // Otherwise, we just have to show a generic error
        setFlashMessage({
          message:
            result.message ||
            "There was a problem sharing your feedback. Please try again or contact us.",
          type: "error",
        });
      }
    } catch (error) {
      // If we've been provided with errors, loop through them
      if (error.errors) {
        Object.entries(error.errors).forEach(([key, message]) => {
          setError(key, { type: "manual", message });
        });
      }

      setFlashMessage(
        "There was a problem saving your response. Please try again or contact us for help.",
      );
    } finally {
      setIsSaving(false);
    }
  };

  const onSubmit = (data) => {
    clearErrors();
    setFlashMessage({ message: null, type: null });
    handleFeedbackSubmit(data);
  };

  if (!session) {
    return null;
  }

  return (
    <Form
      onSubmit={handleSubmit(onSubmit)}
      buttonLabel={buttonLabel}
      busyButtonLabel="Saving..."
      flashMessage={flashMessage}
      isBusy={isSubmitting || isValidating || isSaving}
    >
      <Form.TextareaField
        name="text"
        label=""
        placeholder={placeholderText}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...register("text", { required: "Please enter your response" })}
        error={errors?.text?.message}
      />
    </Form>
  );
};

export default FeedbackForm;
